import { api } from "@/shared/api/instance";
import type { RolesDictionaryResponse, User } from "../types/users.types";

interface ApiResponse<T> {
  data: T;
}

export interface CreateManagerDto {
  login: string;
  name: string;
  role: string;
  surname: string;
}
export interface EditManagerDto {
  name: string;
  role: string;
  surname: string;
}

export const getUsers = async (query: any = {}): Promise<User[]> => {
  const response = await api.get<ApiResponse<User[]>>("/api/v1/manager", {
    params: query,
  });
  return response.data.data;
};

export const getEmployeeRoles = async (): Promise<RolesDictionaryResponse> => {
  const response = await api.get<RolesDictionaryResponse>(
    "/api/v1/dictionary/employee_roles"
  );
  return response.data;
};

export const createManager = async (
  payload: CreateManagerDto
): Promise<User> => {
  const response = await api.post<User>("/api/v1/manager", payload);

  return response.data;
};
export const editManager = async (
  id: number,
  payload: EditManagerDto
): Promise<User> => {
  const response = await api.put<User>(`/api/v1/manager/${id}`, payload);

  return response.data;
};
export const deleteManager = async (id: number): Promise<User> => {
  const response = await api.delete<User>(`/api/v1/manager/${id}`);

  return response.data;
};
